import React from 'react';
import '../../assets/css/ThemeSwitchLoader.css';

const ThemeSwitchLoader = ({ isVisible, isDarkMode }) => {
  if (!isVisible) return null;

  return (
    <div className={`theme-switch-overlay ${isDarkMode ? 'to-dark' : 'to-light'}`}>
      <div className="theme-switch-content">
        {/* Sun Icon */}
        <div className={`theme-icon sun-icon ${isDarkMode ? 'fade-out' : 'fade-in'}`}>
          <svg width="80" height="80" viewBox="0 0 24 24" fill="var(--orange-bg)">
            <path d="M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zM2 13h2c.55 0 1-.45 1-1s-.45-1-1-1H2c-.55 0-1 .45-1 1s.45 1 1 1zm18 0h2c.55 0 1-.45 1-1s-.45-1-1-1h-2c-.55 0-1 .45-1 1s.45 1 1 1zM11 2v2c0 .55.45 1 1 1s1-.45 1-1V2c0-.55-.45-1-1-1s-1 .45-1 1zm0 18v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1zM5.99 4.58c-.39-.39-1.03-.39-1.41 0-.39.39-.39 1.03 0 1.41l1.06 1.06c.39.39 1.03.39 1.41 0s.39-1.03 0-1.41L5.99 4.58zm12.37 12.37c-.39-.39-1.03-.39-1.41 0-.39.39-.39 1.03 0 1.41l1.06 1.06c.39.39 1.03.39 1.41 0 .39-.39.39-1.03 0-1.41l-1.06-1.06zm1.06-10.96c.39-.39.39-1.03 0-1.41-.39-.39-1.03-.39-1.41 0l-1.06 1.06c-.39.39-.39 1.03 0 1.41s1.03.39 1.41 0l1.06-1.06zM7.05 18.36c.39-.39.39-1.03 0-1.41-.39-.39-1.03-.39-1.41 0l-1.06 1.06c-.39.39-.39 1.03 0 1.41s1.03.39 1.41 0l1.06-1.06z" />
          </svg>
        </div>

        {/* Moon Icon */}
        <div className={`theme-icon moon-icon ${isDarkMode ? 'fade-in' : 'fade-out'}`}>
          <svg width="80" height="80" viewBox="0 0 24 24" fill="var(--teal-bg)">
            <path d="M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9c0-.46-.04-.92-.1-1.36-.98 1.37-2.58 2.26-4.4 2.26-3.03 0-5.5-2.47-5.5-5.5 0-1.82.89-3.42 2.26-4.4-.44-.06-.9-.1-1.36-.1z" />
          </svg>
        </div>

        {/* Rays for light mode */}
        {!isDarkMode && (
          <div className="rays-container">
            <div className="ray ray-1"></div>
            <div className="ray ray-2"></div>
            <div className="ray ray-3"></div>
            <div className="ray ray-4"></div>
          </div>
        )}

        {/* Stars for dark mode */}
        {isDarkMode && (
          <div className="stars-container">
            <div className="star star-1"></div>
            <div className="star star-2"></div>
            <div className="star star-3"></div>
            <div className="star star-4"></div>
            <div className="star star-5"></div>
            <div className="star star-6"></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ThemeSwitchLoader;
